
import { Component, Prop, Vue, Emit } from "vue-property-decorator";
import WxPay from "@/views/Components/pay.vue";

import { current } from "@/contants/current";

@Component({ components: { WxPay } })
export default class Pay extends Vue {
  private m: string = "";
  private muid: number = 0;
  private datas: any = {}; //总数据
  private money_desc: string = ""; //费用说明
  private onLineList: any[] = []; // 线上支付列表
  private underLineList: any[] = []; // 线下支付列表
  private selectPayType: any = {}; // 选中的支付方式
  private current: any = {};
  private wxData: any = {};
  private timer: any; //倒计时
  private payCode: any = {};
  private payShow: any = false;
  private orderid: string = ""; //订单号

  private falgs: any = {
    loading: false,
    isPay: true,
    showPopup: false,
  };
  private payBtnMsg = "去支付";
  /**
   * @description: 将票种数据给父组件
   */
  @Emit("handleToPay")
  handleToPay(type: string) {
    let payDatas: any;
    if (type == "next") {
      payDatas = {
        type,
        UserEntity: [],
      };
    } else {
      payDatas = {
        type,
      };
    }
    return payDatas;
  }

  created() {
    this.current = new current();
    this.m = String(this.$route.query.m);
    this.GetSignMeetingUserByMu();
  }

  /**
   * @title 获取当前登录账户报名信息接口
   * @date 2020-01-16
   */
  async GetSignMeetingUserByMu() {
    this.falgs.loading = true;
    let params = {
      m: this.m,
    };
    let _userInfoRes = await this.$http.SignUp.GetSignMeetingUserByMu(params);
    this.muid = _userInfoRes.CurUserEntity.muid;
    console.log("_userInfoRes", _userInfoRes);
    if (_userInfoRes.Code === 1000) {
      this.InitPayConfig();
    }
  }

  /**
   * @title 初始化支付接口
   * @date 2020-01-16
   */
  async InitPayConfig() {
    let params = {
      m: this.m,
      muid: this.muid,
    };
    let res = await this.$http.Pay.InitPayConfig(params);
    console.log(res);

    if (res.Code === 1000) {
      this.datas = res;
      this.selectPayType = res.PayEntitys[0];
      this.money_desc = res.signUp_Set.money_desc;
      for (var i in res.PayEntitys) {
        if (res.PayEntitys[i].paycode) {
          // 线上支付列表
          this.onLineList.push(res.PayEntitys[i]);
        } else {
          // 线下支付列表
          this.underLineList.push(res.PayEntitys[i]);
        }
      }
      this.falgs.loading = false;
    }
  }
  /**
   * @title 支付
   */
  async handlePay(type: string) {
    var _that = this
    
    if (this.falgs.isPay) {
      let { paytype, paycode } = this.selectPayType;
      console.log(paytype >= 4)
      if (paytype >= 4 ) {
        let params = {
          m: this.$route.query.m,
          orderid: this.orderid,
          showTab: '3',
        };
        this.$router.push({
          path: "/personalCenter",
          query: params,
        })
      }else{
        this.falgs.isPay = false;
        this.falgs.loading = true;
        this.payBtnMsg = "请稍后...";
        let IsMobile = this.current.is_Mobile();
        let IsWxClient = this.current.isWeiXin();
        let { paytype, paycode } = this.selectPayType;
        let params = {
          m: this.m,
          muid: this.muid,
          Orderid: '',
          PayType: paytype,
          PayCode: paycode,
          IsMobile,
          IsWxClient,
        };
        let res = await this.$http.Pay.CreatePayOrder(params);

        if (res.Code === 1000) {
          if (this.selectPayType.paytype === 1) {
            if ( this.selectPayType.IsPayRed ){
              window.location.href = res.callback_url
            }else{
              this.payShow = true
              this.payCode = 'data:image/gif;base64,' + res.code_url
              this.orderid = res.orderid
              _that.timer = setInterval(() => {
                _that.QueryOrder()
              }, 1000)
            }
          }else if (this.selectPayType.paytype === 3) {
            this.orderid = res.orderid;
            //微信支付
            this.wxData = {
              orderid: res.orderid,
              paymoney: this.datas.Money,
              code_url: res.code_url,
            };
            this.falgs.showPopup = true;

            this.timer = setInterval(() => {
              this.QueryOrder();
            }, 1000);
          }
        }
        this.falgs.isPay = true;
        this.falgs.loading = false;
        this.payBtnMsg = "去支付";
      }
    }
  }
  /**
   * 查询订单是否支付状态
   */

  async QueryOrder() {
    try {
      let m = this.m;
      let params = {
        m,
        orderid: this.orderid,
      };
      let _Res = await this.$http.Pay.QueryOrder(params);
      const _params = this.$route.query;

      if (_Res.Code === 1000) {
        clearInterval(this.timer);
        this.falgs.showPopup = false;
        this.$message({ message: "支付成功", type: "success", duration: 6000 });
        this.$router.push({
          path: "/personalCenter",
          query: _params,
        });
      }
    } catch (err) {
      console.log(err);
    }
  }
  /**
   * @title 选择支付方式
   */
  handleChoosePayType(item: any) {
    this.selectPayType = item;
  }
  closePay(){
    this.payShow = false
    this.payBtnMsg = '去支付'
  }
}
